@for (value of values; track $index) {
    <span class="me-1 p-1 border rounded">{{ value }}</span>
}

